import * as React from 'react';
import { DefaultLayout } from '../../../../components/DefaultLayout';
import { Seo } from "../../../../components/Seo";

import { YandexMetrika } from '../../../../components/YandexMetrika';
import { MailRu } from '../../../../components/MailRu';
import { TikTok } from '../../../../components/TikTok';
import { VKPixel } from '../../../../components/VKPixel';
import { AdvCake } from '../../../../components/AdvCake';

import { HeaderLogoAndTel } from "../../../../components/HeaderLogoAndTel";
import { FooterFull } from "../../../../components/FooterFull";
import {
  Info,
  Subs
}
  from "../../../../components/LandingTemplates/subtitry_k_serialam_na_angliyskom_yazyke";
import info from "./info.json";
import subs from "./subs.json";

const TITLE = 'Cкачать бесплатно английские субтитры к сериалу Hannibal | Центр образовательных технологий Advance';
const DESCRIPTION = 'Субтитры на английском языке к сериалу Hannibal | Центр образовательных технологий Advance ✅ Cкачать бесплатно ☝';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <div className="container">
      <HeaderLogoAndTel/>
    </div>

    <main style={{ fontFamily: `"Montserrat", sans-serif` }}>
      <Info subPageName={"Hannibal"} data={info}/>
      <Subs data={subs}/>
    </main>

    <FooterFull/>
  </DefaultLayout>
);
export default Page;
